export const breakpoints = {
  sm: 768,
  md: 1024,
  lg: 1440,
  huge: 1050,
  large: 1030,
  medium: 850,
  phone: 450
};

export const smaller = width => `@media screen and (max-width: ${width}px)`;
export const smallerHeight = height => `@media screen and (max-height: ${height}px)`;
export const widerThan = width => `@media screen and (min-width: ${width}px)`;

export const isHorizontal = smaller(breakpoints.medium);
